import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export function useStructure() {
  const store = useStore();
  const route = useRoute();

  const password = computed(() => store.getters.password);
  const info = computed(() => store.getters.info);
  const showFacilitiesMenu = computed(() => store.getters.showFacilitiesMenu);
  const monitoringStruct = computed(() => store.getters.monitoringStruct);
  const monitoringUpdate = computed(() => store.getters.monitoringUpdate);
  const typeFormat = computed(() => store.getters.typeFormat);

  const server = computed(() => store.getters.server);

  const getNodeKey = (node, index) => {
    return `${node.facility_id}_${node.node_name}_${index}`;
  };

  const toColor = (color) => {
    let fill = "#FFFFFF";
    let hex = color.toString(16);
    if (hex) {
      hex = "#" + hex;
      if (hex.length > 1 && hex.length < 7) {
        const count = 7 - hex.length;
        for (let i = 0; i < count; i++) {
          hex = hex + "0";
        }
      }
      if (hex.length === 7) {
        hex = hex[0] + hex[5] + hex[6] + hex[3] + hex[4] + hex[1] + hex[2];
      }
      fill = hex;
    }
    return fill;
  };

  const prepareEvent = (event) => {
    let result = null;
    if (event?.eventType) {
      result = event.eventType.name;
    }
    if (event?.eventType?.eventCategory) {
      result = result
        ? `${result} (${event.eventType.eventCategory.name});`
        : event.eventType.eventCategory.name;
    }
    result = `${result} ${typeFormat.value(new Date(event.date), "date-time")}`;
    return result;
  };

  const rowClass = (node) => {
    const active = node.facility_id == route.params.facility_id;
    if (!monitoringStruct.value?.length) {
      node.node_name_desc = "Соединение отсутствует";
      return { "row-accessories-yellow": true, active: active };
    }

    let facility = monitoringStruct.value.find(
      (item) => item.facilityId === node.facility_id
    );

    if ((!facility || facility.groupId === null) && node.children?.length) {
      const childrenIds = Array.from(node.children, (child) => child.facility_id);
      const children = monitoringStruct.value.filter((item) =>
        childrenIds.includes(item.facilityId)
      );

      if (children.length) {
        facility = Math.max(...children.map((o) => o.groupId));
        facility = children.reduce((max, current) =>
          max.groupId > current.groupId ? max : current
        );
      }
    }

    if (facility && !facility.groupId) {
      const parent = monitoringStruct.value.find(
        (item) => item.facilityId === facility.facilityMonitoringParentId
      );
      const event = parent
        ? parent.eventList.find((item) => item.flangeNo === node.parent_flange_no_min)
        : null;
      facility.activeEvent = event ? prepareEvent(event) : null;
      facility.color = event?.eventType?.color;
      facility.groupId = event?.eventType?.groupId;
    }

    if (facility) {
      node.node_name_desc = facility.activeEvent
        ? facility.activeEvent
        : node.node_name;

      switch (facility.groupId) {
        case 2:
          return { "row-accessories-yellow": true, active: active };
        case 1:
        case 3:
          return { "row-accessories-green": true, active: active };
        case 4:
          return { "row-accessories-red": true, active: active };
        case 5:
          return { "row-accessories-orange": true, active: active };
        default:
          return { active: active };
      }
    }
    return { active: active };
  };

  const setMonitoringStruct = (data) => store.dispatch('setMonitoringStruct', data);
  const addScriptLog = (data) => store.dispatch('addScriptLog', data);
  const clearFacilityData = () => store.dispatch('clearFacilityData');
  const setStruct = (data) => store.dispatch('setStruct', data);

  return {
    password,
    info,
    showFacilitiesMenu,
    monitoringStruct,
    monitoringUpdate,
    typeFormat,
    server,

    toColor,
    prepareEvent,
    rowClass,
    getNodeKey,

    setMonitoringStruct,
    addScriptLog,
    clearFacilityData,
    setStruct,
  };
}